{
  "title": "Shocking Grasp",
  "source": "Player's Handbook",
  "levelAndSchool": "Evocation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "Lightning springs from your hand to deliver a shock to a creature you try to touch. Make a melee spell attack against the target. You have advantage on the attack roll if the target is wearing armor made of metal. On a hit, the target takes 1d8 lightning damage, and it can’t take reactions until the start of its next turn.",
    "At Higher Levels. The spell’s damage increases by 1d8 when you reach 5th level (2d8), 11th level (3d8), and 17th level (4d8)."
  ],
  "spellLists": ["artificer", "eldritch-knight", "arcane-trickster", "sorcerer", "wizard"]
}
